import { FileSignature, Loader2, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export default function SignDialog({ signDoc, setSignDoc, signForm, setSignForm, signFile, setSignFile, signBusy, submitSign }) {
  return (
    <Dialog open={!!signDoc} onOpenChange={(open) => !open && setSignDoc(null)}>
      <DialogContent className="max-w-lg" data-testid="exports-sign-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileSignature className="h-4 w-4" /> Firma eIDAS</DialogTitle>
          <DialogDescription>
            Carica una copia firmata digitalmente del documento (PDF PAdES, DOCX firmato Office, oppure busta CAdES <code>.p7m</code>).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={submitSign} className="space-y-3" data-testid="exports-sign-form">
          <div className="space-y-1.5">
            <Label htmlFor="signer-name">Nome firmatario *</Label>
            <Input id="signer-name" required value={signForm.signer_name}
              onChange={(e) => setSignForm({ ...signForm, signer_name: e.target.value })}
              placeholder="Es. Mario Rossi" data-testid="sign-signer-name" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5">
              <Label htmlFor="signer-cf">Codice fiscale</Label>
              <Input id="signer-cf" value={signForm.signer_fiscal_code}
                onChange={(e) => setSignForm({ ...signForm, signer_fiscal_code: e.target.value.toUpperCase() })}
                placeholder="RSSMRA80A01H501Z" data-testid="sign-signer-cf" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="signer-qtsp">QTSP</Label>
              <Input id="signer-qtsp" value={signForm.qtsp_provider}
                onChange={(e) => setSignForm({ ...signForm, qtsp_provider: e.target.value })}
                placeholder="Aruba, InfoCert, ..." data-testid="sign-signer-qtsp" />
            </div>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="signed-file">File firmato *</Label>
            <Input id="signed-file" type="file" required accept=".pdf,.docx,.p7m"
              onChange={(e) => setSignFile(e.target.files?.[0] || null)} data-testid="sign-file-input" />
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <Button type="button" variant="outline" onClick={() => setSignDoc(null)} data-testid="sign-cancel-button"><X className="h-4 w-4" /> Annulla</Button>
            <Button type="submit" disabled={signBusy || !signFile} className="bg-blue-900 hover:bg-blue-800" data-testid="sign-submit-button">
              {signBusy ? <Loader2 className="h-4 w-4 animate-spin" /> : <FileSignature className="h-4 w-4" />}
              {signBusy ? "Caricamento..." : "Firma"}
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
